<template>
    <b-row  v-bind:style="{backgroundColor: `#001ea0`}"
            class="justify-content-end HeaderButton align-items-center">
        <b-col v-for="(button, index) in buttons" v-bind:key="index"
                cols="12" md="auto" class="py-2">
            <inter-button class="h-b"
                    :confirm="button.confirm ? button.confirm : false"
                    :styleBtn="button.style || 'primaryButton'"
                    @onClick="$emit(button.onClick)"
                    :label="button.label">
            </inter-button>
        </b-col>
    </b-row>
</template>

<script>
    import InterButton from "../form/inter-button/InterButton";
    import {mapGetters} from 'vuex'
    export default {
        name: "HeaderButtons",
        components: {InterButton},
        props: {
            buttons: {
                type: Array,
                default: () => []
            },
        },
        computed: {

            ...mapGetters([
                'currentUser',
            ]),


        },
    }
</script>

<style scoped>

</style>
